/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useEffect, useState } from 'react';
import './CustomRadioForm.css';
import { RadioButton, SearchBox, CheckBox, CustomTooltipWithLabel, SelectDropDown, FilterProp, CustomButton, AddFilterBtnTheme } from '../globalExports';
import { Divider, Chip, Popover } from '@mui/material';
import { cloneDeep } from 'lodash';
import { SearchBoxPropTypes } from '../SearchBox/SearchBox'
import { RadioButtonPropTypes } from '../RadioButton/RadioButton';


export interface ICustomRadioFormProps {
  header: string
  radioButtonConfiguration: RadioButtonPropTypes
  dataList: string[]
  formContainerClass: string
  individualCheckboxStates: string[]
  selectedChipValues: string[]
  selectAllChecked: boolean
  // eslint-disable-next-line @typescript-eslint/ban-types
  handleSelectedData: Function
  filterProps?: FilterProp[]
  searchBoxConfiguration?: SearchBoxPropTypes
  disableCheckBox?: boolean
  showRadioList?: boolean
  isCustom?: boolean
  smallerFont?: boolean
  removePadding?: boolean
  topPadding?: boolean
  radioButtonConfigNotRequired?: boolean
  showFiltersInPopover?: boolean
}

const CustomRadioForm: FC<ICustomRadioFormProps> = (props) => {
  const { header, radioButtonConfiguration, dataList, formContainerClass, individualCheckboxStates,
    selectedChipValues, selectAllChecked, handleSelectedData, filterProps,
    searchBoxConfiguration, disableCheckBox, showRadioList, smallerFont,
    radioButtonConfigNotRequired = false, removePadding, topPadding, showFiltersInPopover = false
  } = props;
  const [filtersAnchorEl, setFiltersAnchorEl] = useState<HTMLElement | null>(null);
  const appliedFiltersCount = filterProps?.filter((filter) => {
    const value = filter?.filterDropdownProps?.selectValue;
    return Array.isArray(value) ? value?.length > 0 : !!value;
  })?.length ?? 0;
  // const [finalData,setFinalData] = useState<string[][] | null>([])
  const listWithoutHeader = dataList?.filter((item) => !item.endsWith(')'));
  const headerList = dataList?.filter((item) => item.endsWith(')'));
  const [selectedCustomers,setSelectedCustomers] = useState<string[]>([]);
  const customerWiseCharger = headerList.map((customer,index)=>{
      const startIndex = dataList?.indexOf(customer)  + 1;
      const endIndex = index + 1 === headerList?.length ? dataList?.length : dataList?.indexOf(headerList?.[index+1]);
      const chargers = dataList?.slice(startIndex,endIndex);
      return {
        customer,
        chargers
      }
  })
  
  // bulk update chargers selection if customer checkbox state changes
  const handleSelectAllCustomerCharger = (customer:string)=>{
    const customerInfo = customerWiseCharger?.filter(item=>item.customer === customer)?.[0];
    const chargers = customerInfo?.chargers;
    if(selectedCustomers?.includes(customer)){
      handleMultipleCheckboxChange(chargers,false);
      setSelectedCustomers(prev=>prev?.filter(item => item!==customer))
    }else{
      handleMultipleCheckboxChange(chargers,true);
      setSelectedCustomers(prev=>[...prev,customer]);
    }
  }
  const handleMultipleCheckboxChange = (vals:string[],include:boolean)=>{
    let updatedCheckboxStates = cloneDeep(individualCheckboxStates);
    vals.forEach(val=>{
      if (!include) {
        updatedCheckboxStates = updatedCheckboxStates?.filter((item) => item !== val)
      } else {
        if(!updatedCheckboxStates?.includes(val))updatedCheckboxStates?.push(val)
      }
    })
    handleSelectedData?.(updatedCheckboxStates, updatedCheckboxStates, updatedCheckboxStates?.length === listWithoutHeader?.length);
  }


  const handleSelectAllChange = () => {
    !selectAllChecked ? handleSelectedData?.(listWithoutHeader, listWithoutHeader, !selectAllChecked) : handleSelectedData?.([], [], !selectAllChecked);
  };

  const handleIndividualCheckboxChange = (val: string) => {
    let updatedCheckboxStates = cloneDeep(individualCheckboxStates);
    if (updatedCheckboxStates?.includes(val)) {
      updatedCheckboxStates = updatedCheckboxStates?.filter((item) => item !== val)
    } else {
      updatedCheckboxStates?.push(val)
    }
    handleSelectedData?.(updatedCheckboxStates, updatedCheckboxStates, updatedCheckboxStates?.length === listWithoutHeader?.length);
  };

  const handleDeleteChip = (val: string) => {
    let updatedCheckboxStates = cloneDeep(individualCheckboxStates);
    updatedCheckboxStates = updatedCheckboxStates?.filter((item) => item !== val)
    handleSelectedData?.(updatedCheckboxStates, updatedCheckboxStates, updatedCheckboxStates?.length === listWithoutHeader?.length);
  };


  // Update the customer checkbox incase chargers are selected and deselected
  useEffect(()=>{
    const newlySelectedChargers = new Set(individualCheckboxStates);
    
    const newlySelectedCustomers: string[] = customerWiseCharger
          ?.filter(item=>item?.chargers?.every(charger=>newlySelectedChargers?.has(charger)))
          ?.map(item => item?.customer)

    setSelectedCustomers(newlySelectedCustomers);

  },[individualCheckboxStates])

  const renderFilter = (filter: FilterProp, index: number, inPopover = false) => (
    <div key={index} className={inPopover ? 'custom__radio__form-filters-popover-row' : `${!props.isCustom ? 'side__filter__wrap-content-row' : 'wrap_content_row_custom'}`}>
      <div className="side__filter__wrap-content-row-label">{filter?.filterLabel}</div>
      <div className="side__filter__wrap-content">
        <SelectDropDown
          selectValue={filter?.filterDropdownProps?.selectValue}
          selectOptions={filter?.filterDropdownProps?.selectOptions ?? []}
          handleSelectOptionChange={(val) => filter?.filterDropdownProps?.handleSelectOptionChange?.(val)}
          selectDropDownId={filter?.filterDropdownProps?.selectDropDownId ?? ''}
          isMultiSelect={filter?.filterDropdownProps?.isMultiSelect}
          isDisabled={filter?.filterDropdownProps?.isDisabled}
          renderToBody={inPopover || filter?.filterDropdownProps?.renderToBody}
          menuPlacement={inPopover ? 'auto' : filter?.filterDropdownProps?.menuPlacement}
        />
      </div>
    </div>
  );

  return (
    <div className={'custom__radio__form ' + formContainerClass}>
      <div className={smallerFont ? 'custom__radio__form-header_custom ' : 'custom__radio__form-header'}>
        {header}
      </div>
      <div className="custom__radio__form-content">
        {!radioButtonConfigNotRequired &&
          <div className="custom__radio__form-content-top">
            <RadioButton
              smallerFont={true}
              buttonsList={radioButtonConfiguration?.buttonsList}
              handleSelectedRadioBtnChange={radioButtonConfiguration?.handleSelectedRadioBtnChange}
              selectedRadioBtnValue={radioButtonConfiguration?.selectedRadioBtnValue}
              radionBtnGrpName={radioButtonConfiguration?.radionBtnGrpName}
            />
          </div>
        }
        {showRadioList && (
          <div className={'custom__radio__form-content-single-selection-container' + `${removePadding ? '-no-padding' : ''}`}>
            <div className={'custom__radio__form-search-box-container' + `${topPadding ? '-top-padding' : ''}`}>
              <SearchBox
                searchFieldId={searchBoxConfiguration?.searchFieldId ?? ''}
                searchFieldName={searchBoxConfiguration?.searchFieldName}
                searchBoxClassName={searchBoxConfiguration?.searchBoxClassName}
                handleSearch={searchBoxConfiguration?.handleSearch}
                isDisabled={searchBoxConfiguration?.isDisabled}
              />
              {showFiltersInPopover ? (
                filterProps && filterProps?.length > 0 && <div className='custom__radio__form-filters-btn'>
                  <CustomButton
                    buttonId='add_filter_btn'
                    customTheme={AddFilterBtnTheme}
                    buttonIconClassName='rms__table__dashboard__add__filter__btn'
                    buttonText='Filters'
                    btnClassName='add__filter__btn'
                    buttonVariant='outlined'
                    badgeCount={appliedFiltersCount}
                    handleClick={(event) => setFiltersAnchorEl(event?.currentTarget)}
                    handleKeyPress={() => { }}
                  />
                </div>
              ) : (
                <div className={`${props.isCustom ? 'custom-class' : 'search__wrap-right'}`} >
                  {filterProps && filterProps?.length > 0 && filterProps?.map((filter, index) => renderFilter(filter, index))}
                </div>
              )}
            </div>
            <Popover
              open={Boolean(filtersAnchorEl)}
              anchorEl={filtersAnchorEl}
              onClose={() => setFiltersAnchorEl(null)}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              disableAutoFocus
              disableEnforceFocus
              disableRestoreFocus
            >
              <div className='custom__radio__form-filters-popover'>
                {filterProps?.map((filter, index) => renderFilter(filter, index, true))}
              </div>
            </Popover>
            <div className='custom__radio__form-select-all-check-box'>
              <div className={smallerFont ? 'custom__radio__form-checkbox_custom_1' : 'custom__radio__form-checkbox'} >
                <div onClick={() => !disableCheckBox && handleSelectAllChange?.()}>
                  <CheckBox checked={selectAllChecked} isDisabled={disableCheckBox} />
                </div>
                Select All
              </div>
            </div>
            <Divider />
            <div className="custom__radio__form-selected-values-container">
              {selectedChipValues && selectedChipValues.map((value, index) => (
                <Chip
                  key={index}
                  label={<CustomTooltipWithLabel labelId='custom__radio__form-checkbox-text' label={value} />}
                  onDelete={() => !disableCheckBox && handleDeleteChip(value)}
                  variant='filled'
                  className="chip-item"
                  sx={{
                    marginRight: '10px',
                    marginTop: '10px'
                  }}
                />
              ))}
            </div>
            <div className="custom__radio__form-selected-values-container">
              <div className="custom__radio__form-chargers-selected">
                {selectedChipValues && selectedChipValues.length !== 0 ? selectedChipValues.length : 0} chargers selected
              </div>
            </div>
            <div style={{ overflowX: 'scroll', width: '100%' }}>

              <div className="custom__radio__form-checkbox-list-container">
                {[...Array(Math.ceil(dataList.length / 7)).keys()].map((colIndex) => (
                  <div key={colIndex} className='custom__radio__form-checkbox-individual-column'>
                    {dataList.slice(colIndex * 7, (colIndex + 1) * 7).map((item, index) => (
                      <div key={index} className="custom__radio__form-checkbox-item">
                        {item.endsWith(')') ? (
                          <div className={smallerFont ? 'custom__radio__form-list-header_small' : 'custom__radio__form-list-header'} onClick={()=> !disableCheckBox && handleSelectAllCustomerCharger(item)}>
                              <CheckBox checked={selectedCustomers?.includes(item)} isDisabled={disableCheckBox} />
                              <CustomTooltipWithLabel labelId='custom__radio__form-checkbox-text' label={item} containerClassName='custom__radio__form-checkbox-text' />
                          </div>
                        ) : (
                          <>
                            <div className={smallerFont ? 'custom__radio__form-checkbox_custom_1' : 'custom__radio__form-checkbox'} onClick={() => !disableCheckBox && handleIndividualCheckboxChange(item)}>
                              <CheckBox checked={individualCheckboxStates?.includes(item)} isDisabled={disableCheckBox} />
                              <CustomTooltipWithLabel labelId='custom__radio__form-checkbox-text' label={item} containerClassName='custom__radio__form-checkbox-text' />
                            </div>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                ))}
                {dataList.length === 0 && (
                  <div className="no-entity-found"> No Chargers Available</div>
                )}
              </div>
            </div>

          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(CustomRadioForm);
